import { LoginNotificationComponent } from '../../components/login/AuthNotification';
import {
    useTheme,
    View,
    Heading,
    Text,
    type AuthenticatorProps,
    useAuthenticator,
    Button,
} from '@aws-amplify/ui-react';
import { AsyncDialogPortal } from '../dialog/AsyncDialog';

type Config = Required<AuthenticatorProps>['components'];

const ResetPasswordDeliveryMessage = () => {
    const { codeDeliveryDetails } = useAuthenticator((context) => [
        context.codeDeliveryDetails,
    ]);
    const destination = codeDeliveryDetails?.Destination;

    if (!destination) return null;

    return (
        <Text>
            <Text
                marginTop="0.5rem"
                as="span"
                display="block"
                fontWeight="bold"
            >
                送信先:{destination}
            </Text>
            に認証コードを送信しました.
        </Text>
    );
};

export const AuthenticatorComponent: Config = {
    Header() {
        const { tokens } = useTheme();
        return <View padding={tokens.space.xxl} />;
    },
    Footer() {
        return <AsyncDialogPortal />;
    },
    SignIn: {
        Header() {
            const { tokens } = useTheme();
            return (
                <Heading
                    fontSize={tokens.fontSizes.large}
                    marginTop={tokens.space.xl}
                    marginLeft={tokens.space.xl}
                >
                    Waymark Portal ログイン
                </Heading>
            );
        },
        Footer() {
            const { toForgotPassword } = useAuthenticator();

            return (
                <>
                    <View textAlign="center">
                        <Button
                            fontWeight="bold"
                            onClick={toForgotPassword}
                            size="small"
                            variation="link"
                        >
                            パスワードを忘れましたか？
                        </Button>
                    </View>
                    <LoginNotificationComponent />
                </>
            );
        },
    },
    ConfirmSignIn: {
        Header() {
            const { codeDeliveryDetails } = useAuthenticator((context) => [
                context.codeDeliveryDetails,
            ]);
            const destination = codeDeliveryDetails?.Destination;

            return (
                <>
                    <Heading>認証コード入力</Heading>
                    {destination && (
                        <Text>
                            ログインするには、テキストメッセージに記載されたコードを入力してください.
                            <Text
                                marginTop="0.5rem"
                                marginBottom="0.5rem"
                                as="span"
                                display="block"
                                fontWeight="bold"
                            >
                                送信先:{destination}
                            </Text>
                            到着するまでに 1 分ほどかかる場合があります.
                        </Text>
                    )}
                </>
            );
        },
        Footer() {
            const { codeDeliveryDetails } = useAuthenticator((context) => [
                context.codeDeliveryDetails,
            ]);
            const destination = codeDeliveryDetails?.Destination;
            const isEmail = codeDeliveryDetails?.DeliveryMedium === 'EMAIL';

            if (!destination) return null;

            return (
                <Text className="confirm-sign-in-recovery-message">
                    {isEmail ? 'メール' : 'SMS'}を受信できない場合は
                    テナント管理者に
                    {isEmail ? 'メールアドレス' : '電話番号'}
                    の修正を依頼してください.
                </Text>
            );
        },
    },
    ForceNewPassword: {
        Header() {
            return <Heading>アカウントの初期設定</Heading>;
        },
    },
    ForgotPassword: {
        Header() {
            return <Heading>パスワード再交付</Heading>;
        },
    },
    ConfirmResetPassword: {
        Header() {
            return (
                <>
                    <Heading>パスワード再交付</Heading>
                    <ResetPasswordDeliveryMessage />
                </>
            );
        },
    },
};
